<template>
  <header id='head_top' :style="{background:background}">
    <section class="head_goback" v-if="goApp" @click="goAppBack">
      <i class="iconfont icon-left"></i>
    </section>
    <section class="head_goback" v-if="goBack" @click="$router.go(-1)">
      <i class="iconfont icon-left"></i>
    </section>
    <section class="title_head ellipsis" v-if="headTitle">
      <span class="title_text">{{headTitle}}</span>
    </section>
    <section class="head_share" v-if="share" @click="appShare">
      <i class="iconfont icon-fanhuianniu"></i>
    </section>
    <section class="head_share" v-else>
      <!-- <img src="/app/static/images/fenxiang3x.png" alt=""> -->
    </section>
    <slot name="msite-title"></slot>
  </header>
</template>

<script>
    export default {
        name: "headView",
        props: ['signinUp', 'headTitle', 'goApp', 'goBack', 'background', 'share', 'appTitle', 'appUrl', 'appText', 'appImg',],
        data() {
            return {}
        },
        methods: {
            goAppBack() {
                this.$jsBridge.callHandler(this.$jsBridgeCmd.goBack, {}, (data) => {})
            },
            appShare() {
                console.log(this.appUrl, 222, this.appImg)
                this.$jsBridge.callHandler(this.$jsBridgeCmd.appSharing, {
                    url: this.appUrl,
                    text: this.appText,
                    img: this.appImg,
                    title: this.appTitle
                }, (data) => {
                })
            },
        }

    }
</script>

<style lang="scss" scoped>
  @import '../style/mixin';

  img {
    vertical-align: middle;
  }

  #head_top {
    // background-color: $blue;
    position: fixed;
    z-index: 999;
    left: 0;
    top: 0;
    @include wh(100%, 2.2rem);
    line-height: 2.2rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 .75rem;
  }

  .head_goback {
    @include wh(0.45rem, .85rem);
    line-height: 0;
    margin-top: .7rem;

    i {
      @include sc(0.65rem, #fff);
    }
  }

  .head_share {
    @include wh(.8rem, .75rem);
    line-height: 0;
    margin-top: .75rem;

    img {
      max-width: 100%;
    }
  }

  .head_login {
    right: 0.55rem;
    @include sc(0.65rem, #fff);
    @include ct;

    .login_span {
      color: #fff;
    }

    .user_avatar {
      fill: #fff;
      @include wh(.8rem, .8rem);
    }
  }

  .title_head {
    width: 14.3rem;
    color: #fff;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    .title_text {
      @include sc(0.75rem, #fff);
      text-align: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/compontents/headView.vue